import validatorBuilder from 'validator-builder';

let motifAjustementStockValidator = null;

export default class MotifAjustementStock {
    constructor(data) {
        data = data || {};
        this.id = data.id;
        this.code = data.code;
        this.libelle = data.libelle;
    }

    isValid() {
        motifAjustementStockValidator = motifAjustementStockValidator || validatorBuilder.getInstanceFor('MotifAjustementStock');
        const validationResults = motifAjustementStockValidator.validate(this);
        return validationResults.isValid;
    }
}
